import React, { useEffect, useState } from "react";
import { Dropdown, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { LandingBlockTypes, moderationState } from "@/const";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard } from "@components/Pages";
import { buildQS, url_reverse } from "@components/Utils";

export default function LandingAddGamesScreen() {
    const { t } = useTranslation();
    const { slug, selection_id } = useParams();
    const apiUrl = url_reverse("api:landing:add_games", { selection_id });
    const { apiData, setApiData } = useAppApi(apiUrl);
    const [selectedGame, setSelectedGame] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const { api_post, api_get } = useRequest();
    const [isFetching, setIsFetching] = useState(null);

    useEffect(() => {
        if (apiData) {
            setAllSelected(false);
            setSelectedGame([]);
        }
    }, [apiData?.pager?.number]);

    const header = (
        <>
            <Link to={url_reverse("admin:event:landing", { slug, selection_id })}>{t("Блоки")}</Link>
            <span> – </span>
            {t("Добавить игры")}
        </>
    );

    const handleSaveGame = (block_id) => {
        api_post(null, apiUrl, {
            params: { action: "add_games_to_block", block_id, ids: selectedGame },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                    setSelectedGame([]);
                    setAllSelected(false);
                }
            },
        });
    };

    const headerTools = (
        <Dropdown show={Boolean(isOpen)} onToggle={() => setIsOpen(!isOpen)}>
            <Dropdown.Toggle variant={"dark"} size={"sm"}>
                {t("Добавить в блок")}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {apiData &&
                    apiData.choices.map((el) => (
                        <Dropdown.Item key={el.value} onClick={() => handleSaveGame(el.value)}>
                            {el.label}
                            {el.name === "" ? "" : " - "}
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: el.name.replace(/<p>/g, '<p style="display:inline;margin:0;">'),
                                }}
                            />
                        </Dropdown.Item>
                    ))}
            </Dropdown.Menu>
        </Dropdown>
    );

    const handleSelectAll = () => {
        if (allSelected) {
            setAllSelected(false);
            setSelectedGame([]);
        } else {
            setAllSelected(true);
            setSelectedGame([]);
            setSelectedGame(apiData.object_list.map((el) => el.id));
        }
    };

    const handleCheckBoxChange = (id) => {
        if (selectedGame.includes(id)) {
            setSelectedGame(selectedGame.filter((el) => el !== id));
        } else {
            setSelectedGame([...selectedGame, id]);
        }
    };

    const prepareTooltip = (initial) => {
        if (initial) {
            return initial.map((el) => {
                return <div key={el.id}> {LandingBlockTypes[el.label]}</div>;
            });
        }
    };
    const handleFetchMore = () => {
        const url = apiUrl + "?" + buildQS({ page: apiData.pager?.number + 1 });
        setIsFetching("fetch-more");
        api_get(null, url, {
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData((prevState) => {
                        return {
                            ...prevState,
                            object_list: apiData.object_list.concat(resp.object_list),
                            forms_data: resp.forms_data,
                            pager: resp.pager,
                            status: resp.status,
                        };
                    });
                }
            },
            finally: () => setIsFetching(null),
        });
    };

    return (
        <DefaultLayout>
            <CommonCard header={header} headerTools={headerTools}>
                {apiData && (
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>{t("Игра")}</th>
                                <th>{t("Участие")}</th>
                                <th>{t("Материалы")}</th>
                                <th>{t("Готов к размещению")}</th>
                                <th width="30px">
                                    <DevForm.Checkbox checked={allSelected} onChange={handleSelectAll} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {apiData.object_list.map((el) => (
                                <tr key={el.id}>
                                    <td>
                                        <Link to={url_reverse("games:admin", { game_id: el.game.id })}>
                                            {el.game.base_locale_object.name}{" "}
                                            {el.__in_blocks_included.length !== 0 && (
                                                <Awesome
                                                    type="info"
                                                    tooltip={prepareTooltip(el.__in_blocks_included)}
                                                />
                                            )}
                                        </Link>
                                    </td>
                                    <td>{el.moderation_state === "material_request" ? t("Не принял") : t("Принял")}</td>
                                    <td>{moderationState[el.moderation_state]}</td>
                                    <td>
                                        {el.game.publication_state === "done" && el.moderation_state === "review_passed"
                                            ? t("Да")
                                            : t("Нет")}
                                    </td>
                                    <td>
                                        <DevForm.Checkbox
                                            checked={selectedGame.includes(el.id)}
                                            onChange={() => handleCheckBoxChange(el.id)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}

                {apiData && apiData.pager?.number < apiData.pager?.num_pages && (
                    <DevForm.Button className="mt-3" name="fetch-more" onClick={handleFetchMore} isLoading={isFetching}>
                        {t("Загрузить еще")}
                    </DevForm.Button>
                )}
            </CommonCard>
        </DefaultLayout>
    );
}
